/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: ISettings.ts
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  26.09.22 2:34 pm.
 * Last modified: 26.09.22 2:34 pm.
 *
 * More information at: https://egt-digital.com/
 */
import { LOBBY_SECTION_NAME } from '../constants';
import IApplicationOptions from './IApplicationOptions';
import { INormalizedGameResponse } from './IGameSettings';
import ISectionSettings from './ISectionSettings';

interface ISettings extends IApplicationOptions {
    units: number;
    currency: string;
    selectedSection: string;
    sections: ISectionSettings[];
    supportedGames: INormalizedGameResponse;
    supportedLanguages: string[];
    host: string;
    apiHost: string;
    redirectHost: string;
    isSettingsModalOpen: boolean;
    isSearchOpen: boolean;
}

export const defaultSettings: ISettings = {
    languageCode: 'EN',
    units: 100,
    currency: 'EGT',
    selectedSection: LOBBY_SECTION_NAME,
    sections: [],
    supportedGames: {},
    supportedLanguages: ['EN'],
    playerId: '',
    gameKey: '',
    openType: 'fullscreen',
    mode: 'mobile',
    // @ts-ignore
    host: window.lobbySsi?.lobbyHost || '',
    // @ts-ignore
    apiHost: window.lobbySsi?.apiIntegrationHost || '',
    // @ts-ignore
    redirectHost: window.lobbySsi?.redirectHost || '',
    isSettingsModalOpen: false,
    isSearchOpen: false,
    useUpdateResizables: false,
};

export default ISettings;
